export default __webpack_public_path__ + "static/media/White-Flower-Cake.73eae447.jpg";